import type {
  AffiliatePaymentEventShape,
  AffiliatePaymentMethodShape
} from 'Services/SalesManagement/Features/Order/orderSlice'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { type FC, useState } from 'react'
import { t } from 'ttag'

const AffiliatePaymentMethod: FC<{
  payment_method: AffiliatePaymentMethodShape
}> = ({ payment_method }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton aria-label={t`Expand row`} size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{showValueOrHyphen(payment_method.transaction_id)}</TableCell>
        <TableCell>{datetimeFormatter(payment_method.created)}</TableCell>
        <TableCell>{showValueOrHyphen(payment_method.payment_operator)}</TableCell>
        <TableCell>{showValueOrHyphen(payment_method.card_pan)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }} component="div">
                {t`Payment events`}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{t`External timestamp`}</TableCell>
                    <TableCell>{t`Status`}</TableCell>
                    <TableCell>{t`Note`}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {payment_method.events.length > 0 ? (
                    <>
                      {payment_method.events.map((event: AffiliatePaymentEventShape, i) => (
                        <TableRow key={`${i}-${event.external_timestamp.toString()}`}>
                          <TableCell component="th" scope="row">
                            {datetimeFormatter(event.external_timestamp)}
                          </TableCell>
                          <TableCell>{event.status}</TableCell>
                          <TableCell>{showValueOrHyphen(event.note)}</TableCell>
                        </TableRow>
                      ))}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2}>{t`No payment events`}</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

export { AffiliatePaymentMethod }
